import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { CommonService as sdkCommonService } from '@techrules/portallib';
import { Observable, catchError, map, throwError } from 'rxjs';
import { TechDialogsService } from '../../shared/tech-dialogs.service';

@Injectable({
  providedIn: 'root',
})
export class BussinesAreaService {
  constructor(
    private sdkCommonService: sdkCommonService,
    private router: Router,
    private dialogService: TechDialogsService
  ) {}

  getBussinesAreaData2(domain: string): Observable<any> {
    return this.sdkCommonService.getBussinesAreaData(domain).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.dialogService.openErrorDialog(err);
        this.router.navigate(['/login']);
        return throwError(err);
      })
    );
  }
}
